<template>
    <div class="frontend-exhibition" v-if="Images">
        <div
        class="exhibitionSlider"
        v-if="newsNowObject"
        :style="`background-image:url(${newsNowObject.image})`"
        >
        <div class="background-gradient"/>
            <ul class="controller" v-if="filterNewsCategory">
                <li 
                v-for="tab in filterNewsCategory" 
                style="color:white;"
                :key="tab.id"
                :class="tab.id == tabNow?'highlight':''"
                @click="goTab(tab.id)">
                    <h4>{{tab[locales]}}</h4>
                </li>
            </ul>
            <div class="wrapperNews" >
                <ul v-if="newsCategoriesObject">
                    <li
                    v-for="(news,index) in newsCategoriesObject"
                    @click="goNews(index)"
                    :key="news.id"
                    :class="index == newsNow?'highlight':''"
                    >
                    <p>{{news.date}}</p>
                    <p>{{news.text}}</p>
                    </li>
                </ul>
                <div 
                class="board"
                >
                    <div>
                        <h4>{{newsNowObject.text}}</h4>
                        <h5>{{newsNowObject.date}}</h5>
                        <p>{{newsNowObject.desc}}</p>
                    </div>
                </div>
                
            </div>
             
        </div>
    </div>
</template>
<script>
import {mapState} from 'vuex'
export default {
    name:'Exhibition',
    props:{
        newsLength:Number
    },
    data(){
        return{
            tabNow:null,
            newsNow:0
        }
    },
    computed: {
        ...mapState('frontend',[
            'Images',
            'locales',
            'News',
            'newsCategories'
        ]),
        filterNewsCategory(){
            if(this.newsCategories){
                const filterCate = this.newsCategories.filter(el=>el.status)
                const hasNews = filterCate.filter(el=>{
                    const news = this.News.map(n=>n.categoryId)
                    return news.includes(el.id)
                })
                console.log(hasNews)
                this.tabNow = hasNews.length>0 || !this.tabNow?hasNews[0].id:this.tabNow
                return hasNews.length>0?hasNews:false
            }
        },
        newsCategoriesObject(){
            if(this.News && this.locales && this.filterNewsCategory && this.tabNow){
                const showNews = this.News.filter(el=>el.categoryId == this.tabNow)
                const mapNews = showNews.map(item=>{
                const textLocales = 'news'+this.locales.slice(4,7)
                const descLocales = 'desc'+this.locales.slice(4,7)
                    const arr = {
                        date:item['date'].toDateString(),
                        image:item['imagePath'],
                        text:item[textLocales],
                        desc:item[descLocales]
                    }
                    return arr
                })
                return mapNews
            }
        },
        newsNowObject(){
            if(this.newsCategoriesObject){
                return this.newsCategoriesObject[this.newsNow]
            }
        },
    },
    mounted(){

    },
    methods:{
        goTab(i){
            this.tabNow = i
        },
        goNews(i){
            this.newsNow = i
        },
    },
    watch:{
        tabNow(){
            this.newsNow = 0
        }
    },
    beforeDestroy() {
        // clearInterval(this.timer)
    },
}
</script>
